import Phaser from 'phaser';

export class BootScene extends Phaser.Scene {
  constructor() { super('BootScene'); }
  create(): void {
    this.scale.on('resize', () => this.cameras.resize(this.scale.gameSize.width, this.scale.gameSize.height));
    this.scene.start('PreloadScene');
  }
}
